<!DOCTYPE html>
<html lang="pt-br">

<head>
	<meta charset="utf-8">
	<meta http-equiv="X-UA-Compatible" content="IE=edge">
	<meta name="viewport" content="width=device-width, initial-scale=1">
	<meta name="Description" CONTENT="Author: Lucas Teófilo de Lima Grupo 2E. Author, Category: Books">
	<meta name="google-site-verification" content="+nxGUDJ4QpAZ5l9Bsjdi102tLVC21AIh5d1Nl23908vVuFHs34=" />
	<title>Cadastro - Grupo 2E</title>
	<meta name="robots" content="noindex,nofollow">
	<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" rel="stylesheet">
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<style>
		body {
			background-color: #f3f3f3;
			font-family: 'Google Sans', 'Roboto', 'Helvetica', 'Arial', 'sans-serif';
			text-align: justify;
			text-justify: inter-word;
		}
	</style>
</head>

<body>
	<div class="containerr" style="max-width: 1200px; width: 100%; margin: 0 auto;">
		<div class="row">
			<div class="col-12">
				<form #cadastroForm="ngForm">
					<div class="card">
						<div class="card-header" style="background-color: #fff; width: 100%;">
							<img *ngIf="tp_cadastro == 'rastreei'" class="d-block mx-auto"
								src="../../../../../assets/images/logo/rastreei.png"
								style="margin: 0 auto; max-width: 400px; width: 100%!important;" alt="rastreei">
							<img *ngIf="tp_cadastro == 'faleflex'" class="d-block mx-auto"
								src="../../../../../assets/images/logo/faleflex.png"
								style="margin: 0 auto; max-width: 400px; width: 100%!important;" alt="rastreei">
						</div>
						<hr>
						<div class="card-header" style="background-color: #fff">
							<h3 class="col-12" style="margin-left:0px!important; color: #212529;"> Cadastro - Grupo 2E
							</h3>
							<br>
							<p class="col-12" style="font-size: 14px;margin-left:0px!important">Este formulário tem como
								objetivo a coleta de dados
								para realizar o cadastro do cliente.<br>
								<b style='color:red'>*</b> obrigatório
							</p>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="email_lead" type="email" name="email"
											id="email" class="form-control"
											placeholder="E-mail <b style='color:red'>* </b>" required />
										<label for="email">E-mail: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="cpf_cnpj_lead" type="cpf_cnpj_cliente"
											name="cpf_cnpj_cliente" id="cpf_cnpj_cliente" required class="form-control"
											placeholder="Cnpj <b style='color:red'>* </b>" />
										<label for="cpf_cnpj_cliente">Cnpj: <b style="color:red">* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="razao_social" type="text"
											name="razao_social" id="razao_social" class="form-control" required
											placeholder="Razão social <b style='color:red'>* </b>" />
										<label for="razao_social">Razão social: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="nome_fantasia" type="text"
											name="nome_fantasia" id="nome_fantasia" class="form-control" required
											placeholder="Nome Fantasia <b style='color:red'>* </b>" />
										<label for="nome_fantasia">Nome Fantasia: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="rua" type="text" name="rua" id="rua"
											class="form-control" placeholder="Rua <b style='color:red'>* </b>"
											required />
										<label for="rua">Rua: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="numero" type="text" name="numero"
											id="numero" class="form-control"
											placeholder="Número <b style='color:red'>* </b>" required />
										<label for="numero">Número: <b style='color:red'>* </b></label>
									</div>
								</div>

								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="complemento" type="text"
											name="complemento" id="complemento" class="form-control"
											placeholder="Complemento" />
										<label for="complemento">Complemento: </label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="bairro" type="text" name="bairro"
											id="bairro" class="form-control"
											placeholder="Bairro <b style='color:red'>* </b>" required />
										<label for="bairro">Bairro: <b style='color:red'>* </b></label>
									</div>
								</div>

								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="cidade" type="text" name="cidade"
											id="cidade" class="form-control"
											placeholder="Cidade <b style='color:red'>* </b>" required />
										<label for="nome">Cidade: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<select [disabled]="loading" [(ngModel)]="estado" class="form-select"
											id="floatingSelect" name="estado" required>
											<option value="" disabled selected>Selecione</option>
											<option value="AC">Acre</option>
											<option value="AL">Alagoas</option>
											<option value="AP">Amapá</option>
											<option value="AM">Amazonas</option>
											<option value="BA">Bahia</option>
											<option value="CE">Ceará</option>
											<option value="DF">Distrito Federal</option>
											<option value="ES">Espírito Santo</option>
											<option value="GO">Goiás</option>
											<option value="MA">Maranhão</option>
											<option value="MT">Mato Grosso</option>
											<option value="MS">Mato Grosso do Sul</option>
											<option value="MG">Minas Gerais</option>
											<option value="PA">Pará</option>
											<option value="PB">Paraíba</option>
											<option value="PR">Paraná</option>
											<option value="PE">Pernambuco</option>
											<option value="PI">Piauí</option>
											<option value="RJ">Rio de Janeiro</option>
											<option value="RN">Rio Grande do Norte</option>
											<option value="RS">Rio Grande do Sul</option>
											<option value="RO">Rondônia</option>
											<option value="RR">Roraima</option>
											<option value="SC">Santa Catarina</option>
											<option value="SP">São Paulo</option>
											<option value="SE">Sergipe</option>
											<option value="TO">Tocantins</option>
											<!-- <option value="EX">Estrangeiro</option> -->
										</select>
										<label for="floatingSelect">Estado <b style='color:red'>* </b></label>
									</div>
								</div>

								<div class="col-lg-6">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="cep" type="text" name="cep" id="cep"
											class="form-control" placeholder="Cep <b style='color:red'>* </b>"
											required />
										<label for="nome">Cep: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="observacao" type="text"
											name="observacao" id="observacao" class="form-control"
											placeholder="Observação <b style='color:red'>* </b>" />
										<label for="nome">Observação:</label>
									</div>
								</div>
							</div>
						</div>

						<div class="card-body">
							<div class="card-header ">
								<h3 class="col-12" style="margin-left:0px!important; color: #212529;"> Responsável pelo
									contrato
								</h3>
							</div>
							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="nome_contratante" type="text"
											name="nome_contratante" id="nome_contratante" class="form-control"
											placeholder="Nome <b style='color:red'>* </b>" required />
										<label for="nome_contratante">Nome: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="cpf_contratante" type="text"
											name="cpf_contratante" id="cpf_contratante" class="form-control"
											placeholder="CPF <b style='color:red'>* </b>" required />
										<label for="cpf_contratante">CPF: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="telefone_contratante" type="text"
											name="telefone_contratante" id="telefone_contratante" class="form-control"
											placeholder="Telefone de contato <b style='color:red'>* </b>" required />
										<label for="telefone_contratante">Telefone: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="email_contratante" type="email"
											name="email_contratante" id="email_contratante" class="form-control"
											placeholder="E-mail <b style='color:red'>* </b>" required />
										<label for="email_contratante">E-mail: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>
						</div>

						<div class="card-body">
							<div class="card-header ">
								<h3 class="col-12" style="margin-left:0px!important; color: #212529;"> Responsável
									Financeiro
								</h3>
							</div>
							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="nome_financeiro" type="text"
											name="nome_financeiro" id="nome_contratante" class="form-control"
											placeholder="Nome <b style='color:red'>* </b>" required />
										<label for="nome_contratante">Nome: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="telefone_financeiro" type="text"
											name="telefone_financeiro" id="telefone_financeiro" class="form-control"
											placeholder="Telefone de contato <b style='color:red'>* </b>" required />
										<label for="telefone_financeiro">Telefone de contato: <b style='color:red'>*
											</b></label>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-lg-12">
									<div class="form-floating mb-3">
										<input [disabled]="loading" [(ngModel)]="email_financeiro" type="email"
											name="email_financeiro" id="email_financeiro" class="form-control"
											placeholder="E-mail <b style='color:red'>* </b>" required />
										<label for="email_financeiro">E-mail: <b style='color:red'>* </b></label>
									</div>
								</div>
							</div>

							<button [disabled]="loading" (click)="submitForm(cadastroForm)" type="submit"
								class="btn btn-primary btn-next " rippleEffect>
								<span class="">Cadastrar</span>
								<i data-feather="arrow-right" class="isHidden align-middle ml-sm-25 ml-0"></i>
								<span class="spinner-border-sm align-middle ml-sm-25 ml-0" role="status"
									aria-hidden="true"></span>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>

</body>

</html>